import React from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Link,
} from "@material-ui/core";

export default function CategorySelector({ categories }) {
  const useStyles = makeStyles((theme) => ({
    results: {
      margin: "0px",
    },
    button: {
      "&:hover": { background: "none", boxShadow: "none" },
      "&:active": { background: "none", boxShadow: "none" },
    },
  }));
  const classes = useStyles();

  return (
    <Grid item container xs={12} spacing={2} className={classes.results}>
      {categories.map((category) => {
        return (
          <Grid item xs={12} sm={6} md={4} key={category.id}>
            <Link href={`${category.url}`}>
              <Card>
                <CardActionArea className={classes.button}>
                  <CardMedia
                    component="img"
                    alt={category.title + " Category"}
                    image={category.thumbnail}
                    title={category.title}
                  />
                  <CardContent>
                    <Typography gutterBottom align="center" component="h2">
                      {category.title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
}
